<template>
  <div class="position-relative" style="height: 90vh">
    <div>
      <h1 class="font-title text-center mb-0" style="
                  font-size: 2rem;
                ">
        北京四川大厦
      </h1>
      <p class="text-center">
        Beijing Sichuan Mansion Building
      </p>
    </div>

        <div class="w-100" style="height: 85vh;">
            <Model systemKey="kttf"/>
        </div>

    <div class="w-25 position-absolute" style="top: 1rem; left: 0">
      <b-card class="card-border-custom">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-lightning-fill class="mr-1" variant="primary"/>
          今日能耗
        </b-card-title>
        <b-row>
          <b-col cols="4">
            <b-alert show variant="danger" class="mb-0">
              <div class="alert-body text-center py-2 px-0" id="tooltip-target-1" style="height: 13vh">
                <b-icon-lightning-fill font-scale="1.5"/>
                <p>耗电量</p>
                <h1 class="text-danger text-truncate mb-0">
                  {{ todayData.耗电量.toFixed(2) }}
                </h1>
                <label>kWh</label>
                <b-tooltip target="tooltip-target-1" triggers="hover" variant="danger">
                  截至
                  <span>{{ nowDate }}</span>
                </b-tooltip>
              </div>
            </b-alert>
          </b-col>

          <b-col cols="4">
            <b-alert show variant="success" class="mb-0">
              <div class="alert-body text-center py-2 px-0" id="tooltip-target-2" style="height: 13vh">
                <b-icon-sunrise-fill font-scale="1.5"/>
                <p>发电量</p>
                <h1 class="text-success text-truncate mb-0">
                  {{ todayData.发电量.toFixed(2) }}
                </h1>
                <label>kWh</label>
                <b-tooltip target="tooltip-target-2" triggers="hover" variant="success">
                  截至
                  <span>{{ nowDate }}</span>
                </b-tooltip>
              </div>
            </b-alert>
          </b-col>

          <b-col cols="4">
            <b-alert show variant="warning" class="mb-0">
              <div class="alert-body text-center py-2 px-0" id="tooltip-target-3" style="height: 13vh">
                <b-icon-safe-fill font-scale="1.5"/>
                <p>用水量</p>
                <h1 class="text-warning text-truncate mb-0">
                  {{ todayData.用水量.toFixed(2) }}
                </h1>
                <label>m<sup>3</sup></label>
                <b-tooltip target="tooltip-target-3" triggers="hover" variant="warning">
                  截至
                  <span>{{ nowDate }}</span>
                </b-tooltip>
              </div>
            </b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="card-border-custom">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-tree-fill class="mr-1" variant="primary"/>
          今日碳排
        </b-card-title>
        <b-row>
          <b-col cols="6">
            <div class="card-border-custom middle_box p-2">
              <div class="d-flex align-items-center">
                <b-avatar rounded variant="light-info" class="mr-1" size="48">
                  <b-icon-graph-up scale="2"/>
                </b-avatar>
                <div>
                  碳排放<br/>
                  <span class="h3 text-info">{{ todayData.碳排放.toFixed(2) }}</span><br/>
                  <small>&nbsp;kgCO<sub>2</sub></small>
                </div>
              </div>
              <div class="mt-50 text-truncate"><small>≈ 燃烧标煤
                <b-badge
                    variant="light-info">{{ todayData.燃烧标煤.toFixed(2) }}
                </b-badge>
                t</small>
              </div>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="card-border-custom middle_box p-2">
              <div class="d-flex align-items-center">
                <b-avatar rounded variant="light-success" class="mr-1" size="48">
                  <b-icon-graph-down scale="2"/>
                </b-avatar>
                <div>
                  减碳量<br/>
                  <span class="h3 text-success">{{ todayData.减碳量.toFixed(2) }}</span><br/>
                  <small>&nbsp;kgCO<sub>2</sub></small>
                </div>
              </div>
              <div class="mt-50 text-truncate"><small>≈ 植树造林
                <b-badge
                    variant="light-success">{{ todayData.植树造林.toFixed(2) }}
                </b-badge>
                m<sup>2</sup></small>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="card-border-custom">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-pie-chart-fill class="mr-1" variant="primary"/>
          分项能耗
        </b-card-title>
        <div style="height: 10rem" id="container2"></div>
      </b-card>

      <b-card class="card-border-custom mb-0">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-bar-chart-fill class="mr-1" variant="primary"/>
          逐月能耗
        </b-card-title>
        <div style="height: 10rem" id="container1"></div>
      </b-card>
    </div>

    <div class="w-25 position-absolute" style="top: 1rem; right: 0">
      <b-card class="card-border-custom" style="height: 18vh;">
        <b-card-title class="card-title-custom text-truncate">
          <b-icon-gear-fill class="mr-1" variant="primary"/>
          设备状态
        </b-card-title>
        <b-card-text>
          <b-row>
            <b-col cols="6">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <b-icon-hdd-rack-fill/>
                  <span class="ml-1">制冷机</span>
                </div>
                <div>
                  <span class="bullet bullet-primary bullet-sm"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-gear-wide-connected/>
                  <span class="ml-1">冷冻泵</span>
                </div>
                <div>
                  <span class="bullet bullet-secondary bullet-sm"></span>
                  <span class="bullet bullet-primary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-gear-wide-connected/>

                  <span class="ml-1">冷却泵</span>
                </div>
                <div>
                  <span class="bullet bullet-secondary bullet-sm"></span>
                  <span class="bullet bullet-primary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                  <span class="bullet bullet-warning bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-server/>
                  <span class="ml-1">冷却塔</span>
                </div>
                <div>
                  <span class="bullet bullet-secondary bullet-sm"></span>
                  <span class="bullet bullet-primary bullet-sm ml-50"></span>
                  <span class="bullet bullet-secondary bullet-sm ml-50"></span>
                </div>
              </div>
            </b-col>
            <b-col cols="6">
              <div class="d-flex align-items-center justify-content-between">
                <div>
                  <b-icon-wind/>
                  <span class="ml-1">空调机</span>
                </div>
                <div class="text-muted">
                  <span class="text-primary" style="font-weight: bold">5</span> / 10
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-asterisk/>
                  <span class="ml-1">新风机</span>
                </div>
                <div class="text-muted">
                  <span class="text-primary" style="font-weight: bold">6</span> / 12
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-broadcast/>
                  <span class="ml-1">送风机</span>
                </div>
                <div class="text-muted">
                  <span class="text-primary" style="font-weight: bold">4</span> / 9
                </div>
              </div>
              <div class="d-flex align-items-center justify-content-between mt-75">
                <div>
                  <b-icon-bullseye/>
                  <span class="ml-1">排风机</span>
                </div>
                <div class="text-muted">
                  <span class="text-primary" style="font-weight: bold">4</span> / 8
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>

      <b-card class="card-border-custom" style="height: 27vh;">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-sticky-fill class="mr-1" variant="primary"/>
          工单统计
        </b-card-title>
        <b-row>
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.alarm)" v-b-modal:modal-center>
              <b-avatar variant="light-danger">
                <b-icon-exclamation-triangle-fill/>
              </b-avatar>
              <h2 class="text-danger mb-0" style="font-weight: bold">2</h2>
              设备报警
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.fire_alarm)" v-b-modal:modal-center>
              <b-avatar variant="light-warning">
                <b-icon-cone-striped/>
              </b-avatar>
              <h2 class="text-warning mb-0" style="font-weight: bold">0</h2>
              消防报警
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.security_alarm)" v-b-modal:modal-center>
              <b-avatar variant="light-info">
                <b-icon-broadcast-pin/>
              </b-avatar>
              <h2 class="text-info mb-0" style="font-weight: bold">0</h2>
              安防报警
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-2">
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.check_task)" v-b-modal:modal-center>
              <b-avatar variant="light-success">
                <b-icon-clipboard-check/>
              </b-avatar>
              <h2 class="text-success mb-0" style="font-weight: bold">412</h2>
              巡检数量
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.repair)" v-b-modal:modal-center>
              <b-avatar variant="light-primary">
                <b-icon-tools/>
              </b-avatar>
              <h2 class="text-primary mb-0" style="font-weight: bold">4</h2>
              报修数量
            </div>
          </b-col>
          <b-col cols="4">
            <div class="card-border-custom text-center p-75" style="height: 9vh;"
                 @click="showDetailIframe(workOrderData.complaint)" v-b-modal:modal-center>
              <b-avatar variant="light-danger">
                <b-icon-chat-dots-fill/>
              </b-avatar>
              <h2 class="text-danger mb-0" style="font-weight: bold">0</h2>
              投诉数量
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="card-border-custom">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-speedometer2 class="mr-1" variant="primary"/>
          健康度
        </b-card-title>
        <b-row>
          <b-col cols="4">
            <b-alert show variant="primary" class="mt-3">
              <div class="alert-body">
                <h1 style="font-size: 2.5rem" class="mb-0">
                  {{health_score + '%'}}
                </h1>
                <b-icon-star-fill variant="success"></b-icon-star-fill>
                <b-icon-star-fill variant="success"></b-icon-star-fill>
                <b-icon-star-fill variant="success"></b-icon-star-fill>
                <b-icon-star-half variant="success"></b-icon-star-half>
                <b-icon-star variant="success"></b-icon-star>
              </div>
            </b-alert>
          </b-col>
          <b-col cols="8">
            <div style="height: 10rem" id="container3"></div>
          </b-col>
        </b-row>
      </b-card>

      <b-card class="card-border-custom mb-0" style="height: 15vh;">
        <b-card-title class="text-truncate card-title-custom">
          <b-icon-thermometer-half class="mr-1" variant="primary"/>
          室内环境
        </b-card-title>
        <b-row>
          <b-col cols="6">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <b-avatar rounded variant="light-warning" class="mr-1">
                  <b-icon-thermometer-half/>
                </b-avatar>
                温度
              </div>
              <b-badge variant="light-warning">26 ℃</b-badge>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <b-avatar rounded variant="light-info" class="mr-1">
                  <b-icon-thermometer-half/>
                </b-avatar>
                湿度
              </div>
              <b-badge variant="light-info">50 %</b-badge>
            </div>
          </b-col>
        </b-row>
        <b-row class="mt-50">
          <b-col cols="6">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <b-avatar rounded variant="light-success" class="mr-1">
                  <b-icon-thermometer-half/>
                </b-avatar>
                CO<sub>2</sub>
              </div>
              <b-badge variant="light-success">265 ppm</b-badge>
            </div>
          </b-col>
          <b-col cols="6">
            <div class="d-flex align-items-center justify-content-between">
              <div>
                <b-avatar rounded variant="light-danger" class="mr-1">
                  <b-icon-thermometer-half/>
                </b-avatar>
                PM<sub>2.5</sub>
              </div>
              <b-badge variant="light-danger">35 μg/m<sup>3</sup></b-badge>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </div>

    <div class="w-50 px-3 position-absolute" style="bottom: 0rem; left: 50%; transform: translateX(-50%)">
      <b-row>
        <b-col cols="2" v-for="item in sub_system_list" :key="item.index">
          <b-btn block class="mb-1 card-border-custom small_box" variant="text" @click="system_key = item.key">
            <h3>
              <b-icon :icon="item.icon"/>
            </h3>
            <h5>{{ item.name }}</h5>
          </b-btn>
        </b-col>
      </b-row>
    </div>

    <!--  今日工单弹窗-->
    <b-modal id="modal-center" scrollable centered hide-footer size="xl" :title="this.workOrderData.data.name"
             content-class="my-modal-content"
             dialog-class="my-dialog-class">
      <b-embed id="scds-homepage-workOrder-iframe" :src="workOrderData.data.iframe" allow-cross-origin allowfullscreen
        loading="lazy" type="iframe"></b-embed>
    </b-modal>
  </div>


</template>


<script>
import {$themeColors} from "@themeConfig"
import Model from "./components/model.vue"
import {Column, Pie, Line, Area, measureTextWidth,Gauge} from "@antv/g2plot"
import router from "@/router"
import {mapGetters} from 'vuex'
import {momentFmt} from "@/libs/utils/moment";
import todayDataJson from "/public/scds/首页碳排数据.json"
import axios from "axios";
import {showToast} from "@/libs/utils/showToast";
import {nextTick} from "@vue/composition-api";
import store from "@/store";

function renderStatistic(containerWidth, text, style) {
  const textWidth = measureTextWidth(text, style);
  const textHeight = style.lineHeight || style.fontSize
  const R = containerWidth / 2;
  // r^2 = (w / 2)^2 + (h - offsetY)^2
  let scale = 1;
  if (containerWidth < textWidth) {
    scale = Math.min(Math.sqrt(Math.abs(Math.pow(R, 2) / (Math.pow(textWidth / 2, 2) + Math.pow(textHeight, 2)))), 1);
  }
  const textStyleStr = `width:${containerWidth}px;`;
  return `<div style="${textStyleStr};font-size:${scale}em;line-height:${scale < 1 ? 1 : 'inherit'};">${text}</div>`;
}


export default {
  name: "Dashboard",
  components: {
    Model,
  },
  props: {
    data: {
      type: Object,
      default: () => {
      },
    },
  },
  computed: {
    ...mapGetters('appConfig', [
      'skin'
    ])
  },
  data() {
    return {
      system_key: null,
      sub_system_list: [
        {key: "kttf", name: "空调通风", icon: "wind"},
        {key: "zlxt", name: "冷源系统", icon: "snow2"},
        {key: "grxt", name: "热源系统", icon: "hdd-fill"},
        {key: "jps", name: "给排水", icon: "droplet"},
        {key: "bpd", name: "变配电", icon: "lightning-fill"},
        {key: "dtxt", name: "电梯系统", icon: "box-arrow-up"},
        {key: "ggzm", name: "公共照明", icon: "lightbulb-fill"},
        {key: "yjzm", name: "应急照明", icon: "tropical-storm"},
        {key: "hjjc", name: "环境监测", icon: "thermometer-half"},
        {key: "xfxt", name: "消防系统", icon: "shield-fill-exclamation"},
        {key: "afxt", name: "安防系统", icon: "lock-fill"},
        {key: "ybgc", name: "隐蔽工程", icon: "bezier"},
      ],
      font_color: '#b8c2cc',
      piePlot: null,
      nowDate: null,
      todayDataJson: todayDataJson,
      todayData: {
        "耗电量": 0,
        "发电量": 0,
        "用水量": 0,
        "碳排放": 0,
        "减碳量": 0,
        "燃烧标煤": 0,
        "植树造林": 0
      },
      workOrderData:{
        alarm: {
          name: "设备报警",
          color: "danger",
          icon: "icon-alarm",
          size: 3.1,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/alarmRecord/index",
        },
        fire_alarm: {
          name: "消防报警",
          color: "warning",
          icon: "icon-icon-kaiguzhangdan",
          size: 2.8,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/fireAlarmHistoryLog/index",
        },
        security_alarm: {
          name: "安防报警",
          color: "info",
          icon: "icon-tongzhi",
          size: 3.2,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/securityAlarmHistoryLog/index",
        },
        check_task: {
          name: "巡检数量",
          color: "success",
          icon: "icon-inspection",
          size: 3.7,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/checkTask/index",
        },
        repair: {
          name: "报修数量",
          color: "warning",
          icon: "icon-baoxiu",
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/repairRequest/index",
        },
        complaint: {
          name: "投诉数量",
          color: "primary",
          icon: "icon-tousu",
          size: 2.8,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/complaint/index",
        },
        data: {
          name: "设备报警",
          color: "danger",
          icon: "icon-alarm",
          size: 3.1,
          total: 0,
          finished: 0,
          iframe: "app.dreamsfount35.com/ems/alarmRecord/index",
        },
      }, //今日工单中的路径数据
      health_score: 100,
      gaugePlot: null,
    };
  },
  watch: {
    system_key: {
      handler: function (val) {
        if (val) {
          router.push({
            name: "project-scds-subsystems",
            params: {
              project_id: 82,
              system_key: val,
            }
          });
        }
      },
      immediate: true
    },
    skin: {
      handler: function (val) {
        if (val === "dark") {
          this.font_color = "#b8c2cc"
        } else {
          this.font_color = "#6e6b7b"
        }
        this.$nextTick(() => {
          if (this.piePlot) {
            this.piePlot?.update({
              label: {
                style: {
                  textAlign: "center",
                  fill: this.font_color,
                },
              },
              legend: {
                itemName: {
                  style: {
                    fill: this.font_color,
                  },
                },
              },
              statistic: {
                title: {
                  style: {
                    fontSize: "1rem",
                    color: this.font_color,
                  },
                },
                content: {
                  style: {
                    fontSize: "1.286rem",
                    fontWeight: "normal",
                    color: this.font_color,
                  },
                },
              },
            })
          }
        })
      },
      immediate: true, deep: true
    }
  },
  methods: {
    initColumnChart() {
      const data = [
        {
          type: '2023-01',
          sales: 489074,
        },
        {
          type: '2023-02',
          sales: 461176,
        },
        {
          type: '2023-03',
          sales: 437525,
        },
        {
          type: '2023-04',
          sales: 364109,
        },
        {
          type: '2023-05',
          sales: 488957,
        },
        {
          type: '2023-06',
          sales: 665284,
        },
        {
          type: '2023-07',
          sales: 801562,
        },
        {
          type: '2023-08',
          sales: 854351,
        },
        {
          type: '2023-09',
          sales: 695365,
        },
        {
          type: '2023-10',
          sales: 379483,
        },
        {
          type: '2023-11',
          sales: 482338,
        },
        {
          type: '2023-12',
          sales: 553317,
        },
        {
          type: '2024-01',
          sales: 547861,
        },
        {
          type: '2024-02',
          sales: 467864,
        },
        {
          type: '2024-03',
          sales: 443886,
        },
        {
          type: '2024-04',
          sales: 388995,
        },
        {
          type: '2024-05',
          sales: 505809,
        },
        {
          type: '2024-06',
          sales: 134160,
        },
      ];

      const columnPlot = new Column(document.getElementById('container1'), {
        title: {
          visible: true,
          text: '逐月能耗',
        },
        forceFit: true,
        data,
        xField: 'type',
        yField: 'sales',
        color: 'l(90) 0:#1890ffff 1:#1890ff00',
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          line: null,
          grid: null,
          label: null,
        },
        meta: {
          type: {
            alias: '月份',
          },
          sales: {
            alias: '能耗（kWh）',
          },
        },
      });

      columnPlot.render();

    },
    initPieChart() {
      const data = [
        {
          type: '空调用电',
          value: 0.58 * this.todayData.耗电量,
        },
        {
          type: '照明用电',
          value: 0.26 * this.todayData.耗电量,
        },
        {
          type: '插座用电',
          value: 0.13 * this.todayData.耗电量,
        },
        {
          type: '其它用电',
          value: 0.03 * this.todayData.耗电量,
        },
      ];

      this.piePlot = new Pie(document.getElementById('container2'), {
        forceFit: true,
        title: {
          visible: true,
          text: '分项能耗',
        },
        theme: {
          colors10: Object.values($themeColors),
        },
        radius: 0.9,
        innerRadius: 0.6,
        data,
        angleField: 'value',
        colorField: 'type',
        label: {
          type: "inner",
          offset: "-50%",
          autoRotate: false,
          style: {
            textAlign: "center",
            fill: this.font_color,
          },
          formatter: ({percent}) =>
              `${(percent * 100).toFixed(0)}%`,
        },
        legend: {
          position: "left",
          itemName: {
            style: {
              fill: this.font_color,
            },
          },
        },
        pieStyle: {
          lineWidth: 0,
        },
        statistic: {
          title: {
            formatter: () => "合计",
            offsetY: -8,
            style: {
              fontSize: "1rem",
              color: this.font_color,
            },
          },
          content: {
            offsetY: -4,
            // style: {
            //   fontSize: "1.286rem",
            //   fontWeight: "normal",
            //   color: this.font_color,
            // },
            customHtml: (container, view, datum, data) => {
              const { width } = container.getBoundingClientRect();
              const text = datum ? `${datum.value.toFixed(2)}` : `${data.reduce((r, d) => r + d.value, 0).toFixed(2)}`;
              return renderStatistic(width, text, {  fontSize: "1.286rem",
                fontWeight: "normal",
                color: this.font_color, });
            },
          },
        },
        interactions: [
          {
            type: "element-selected",
          },
          {
            type: "element-highlight",
          },
          {
            type: "pie-statistic-active",
            cfg: {
              start: [
                {
                  trigger: "element:mouseenter",
                  action: "pie-statistic:change",
                },
                {
                  trigger: "legend-item:mouseenter",
                  action: "pie-statistic:change",
                },
              ],
              end: [
                {
                  trigger: "element:mouseleave",
                  action: "pie-statistic:reset",
                },
                {
                  trigger: "legend-item:mouseleave",
                  action: "pie-statistic:reset",
                },
              ],
            },
          },
        ],
      });
      this.piePlot.render();
    },
    initAreaChart() {
      const data = [
        {
          time: '00:00',
          type: '实测值',
          value: 4623,
        },
        {
          time: '00:00',
          type: 'MLP预测',
          value: 2208,
        },
        {
          time: '00:00',
          type: 'XGB预测',
          value: 182,
        },
        {
          time: '01:00',
          type: '实测值',
          value: 6145,
        },
        {
          time: '01:00',
          type: 'MLP预测',
          value: 2016,
        },
        {
          time: '01:00',
          type: 'XGB预测',
          value: 257,
        },
        {
          time: '02:00',
          type: '实测值',
          value: 508,
        },
        {
          time: '02:00',
          type: 'MLP预测',
          value: 2916,
        },
        {
          time: '02:00',
          type: 'XGB预测',
          value: 289,
        },
        {
          time: '03:00',
          type: '实测值',
          value: 6268,
        },
        {
          time: '03:00',
          type: 'MLP预测',
          value: 4512,
        },
        {
          time: '03:00',
          type: 'XGB预测',
          value: 428,
        },
        {
          time: '04:00',
          type: '实测值',
          value: 6411,
        },
        {
          time: '04:00',
          type: 'MLP预测',
          value: 8281,
        },
        {
          time: '04:00',
          type: 'XGB预测',
          value: 619,
        },
        {
          time: '05:00',
          type: '实测值',
          value: 1890,
        },
        {
          time: '05:00',
          type: 'MLP预测',
          value: 2008,
        },
        {
          time: '05:00',
          type: 'XGB预测',
          value: 87,
        },
        {
          time: '06:00',
          type: '实测值',
          value: 4251,
        },
        {
          time: '06:00',
          type: 'MLP预测',
          value: 1963,
        },
        {
          time: '06:00',
          type: 'XGB预测',
          value: 706,
        },
        {
          time: '07:00',
          type: '实测值',
          value: 2978,
        },
        {
          time: '07:00',
          type: 'MLP预测',
          value: 2367,
        },
        {
          time: '07:00',
          type: 'XGB预测',
          value: 387,
        },
        {
          time: '08:00',
          type: '实测值',
          value: 3880,
        },
        {
          time: '08:00',
          type: 'MLP预测',
          value: 2956,
        },
        {
          time: '08:00',
          type: 'XGB预测',
          value: 488,
        },
        {
          time: '09:00',
          type: '实测值',
          value: 3606,
        },
        {
          time: '09:00',
          type: 'MLP预测',
          value: 678,
        },
        {
          time: '09:00',
          type: 'XGB预测',
          value: 507,
        },
        {
          time: '10:00',
          type: '实测值',
          value: 4311,
        },
        {
          time: '10:00',
          type: 'MLP预测',
          value: 3188,
        },
        {
          time: '10:00',
          type: 'XGB预测',
          value: 548,
        },
        {
          time: '11:00',
          type: '实测值',
          value: 4116,
        },
        {
          time: '11:00',
          type: 'MLP预测',
          value: 3491,
        },
        {
          time: '11:00',
          type: 'XGB预测',
          value: 456,
        },
        {
          time: '12:00',
          type: '实测值',
          value: 6419,
        },
        {
          time: '12:00',
          type: 'MLP预测',
          value: 2852,
        },
        {
          time: '12:00',
          type: 'XGB预测',
          value: 689,
        },
        {
          time: '13:00',
          type: '实测值',
          value: 1643,
        },
        {
          time: '13:00',
          type: 'MLP预测',
          value: 4788,
        },
        {
          time: '13:00',
          type: 'XGB预测',
          value: 280,
        },
        {
          time: '14:00',
          type: '实测值',
          value: 445,
        },
        {
          time: '14:00',
          type: 'MLP预测',
          value: 4319,
        },
        {
          time: '14:00',
          type: 'XGB预测',
          value: 176,
        },
      ];

      const areaPlot = new Area(document.getElementById('container3'), {
        theme: {
          colors10: Object.values($themeColors),
        },
        legend: {
          itemName: {
            style: {fill: "#82868b"},
          },
          position: "top",
        },
        data,
        xField: "time",
        yField: "value",
        seriesField: "type",
        isStack: false,
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          nice: true,
          grid: null,
          label: null,
        },
        smooth: true,
        meta: {
          value: {
            alias: "数值",
            formatter: (value) => {
              return Math.round(value * 100) / 100;
            },
          },
        },
      });
      areaPlot.render();
    },
    initGaugeChart() {
      this.gaugePlot = new Gauge("container3", {
        percent: 1,
        type: "meter",
        innerRadius: 0.75,
        range: {
          ticks: [0, 1 / 3, 2 / 3, 1],
          color: ["#ea5455", "#ff9f43", "#28c76f"],
        },
        indicator: {
          pointer: {
            style: {
              stroke: "#D0D0D0",
            },
          },
          pin: {
            style: {
              stroke: "#D0D0D0",
            },
          },
        },
        axis: {
          label: {
            formatter(v) {
              return Number(v) * 100;
            },
          },
          subTickLine: {
            count: 3,
          },
        },
      });
      this.gaugePlot.render();
    },

    initData() {
      this.todayData.用水量 = 0;
      this.todayData.耗电量 = 0;
      this.todayData.发电量 = 0;
      this.todayData.碳排放 = 0;
      this.todayData.减碳量 = 0;
      this.todayData.燃烧标煤 = 0;
      this.todayData.植树造林 = 0;
    },
    //定时器，每隔一分钟刷新数据
    initTodayData() {
      let hours = new Date().getHours();
      this.todayDataJson.detail.forEach(item => {
        if (hours >= item.时间.split(':')[0]){
          this.todayData.用水量 += Number(item.用水量);
          this.todayData.耗电量 += Number(item.耗电量);
          this.todayData.发电量 += Number(item.发电量);
          this.todayData.碳排放 += Number(item.碳排放);
          this.todayData.减碳量 += Number(item.减碳量);
          this.todayData.燃烧标煤 += Number(item.燃烧标煤);
          this.todayData.植树造林 += Number(item.植树造林);
        }
      })
    },

    //显示统计数据详情Iframe
    showDetailIframe(item){
      this.workOrderData.data = item;
      let iframeSrc = item.iframe;
      if (iframeSrc) {
        //若链接不以http开始，则加上当前网址的http协议
        const location_protocol = window.location.protocol;
        if (iframeSrc.slice(0, 4) !== "http") {
          iframeSrc = location_protocol + "//" + iframeSrc;
        }
        //对小程序链接单独处理
        if (iframeSrc.indexOf("v4.qiyebox.com") > -1) {
          axios
              .get("https://v4.qiyebox.com/admin/user/info/e9/token")
              .then((res) => {
                const tenant_id = res.data.data.tenant_id;
                const access_token = res.data.data.access_token;
                let symbol =
                    iframeSrc.indexOf("?") > -1 ? "&" : "?";
                iframeSrc +=
                    symbol +
                    "tenant_id=" +
                    tenant_id +
                    "&access_token=" +
                    access_token;
              });
        }
      }
      this.workOrderData.data.iframe = iframeSrc;
      if (iframeSrc) {
        this.load_iframe();
      } else if (iframeSrc === "") {
        showToast(null, "错误：", "此链接为空！");
      }
    },

    //加载iframe
    load_iframe() {
      showToast(null, "提示：", "页面加载中...");
      const postData = {
        accessToken: localStorage.getItem("accessToken"),
        project_id: 72,
      };
      nextTick(() => {
        const iframe_dom = document.getElementById(
            "jsf-homepage-detail-iframe"
        );
        if (iframe_dom) {
          iframe_dom.onload = () => {
            iframe_dom.contentWindow.postMessage(postData, "*");
            // showToast(null, '成功：', '页面已加载！');
          };
        }
      });
    },

    // 首页健康度
    getIndexTopInfos(){
      const project_id = "82";
      store
          .dispatch("projects/getIndexTopInfos")
          .then((response) => {
            console.log('健康度', response);
            this.health_score = Math.ceil(
              response.data.health.score
            );
            if (this.gaugePlot) {
              this.gaugePlot?.update({
                percent: response.data.health.score/100,
              })
            }
          })
          .catch((error) => {
            showToast(error);
          });
    },
  },
  created(){
  },
  mounted() {
    this.initData();
    this.initTodayData();
    setInterval(() => {
      this.initData();
      this.initTodayData()
    }, 1000 * 60);
    this.initColumnChart();
    this.initPieChart();
    /* this.initAreaChart(); */
    this.initGaugeChart();
    // 获取健康度
    this.getIndexTopInfos()
    this.nowDate = momentFmt()

  },
  destroyed() {
  },


};
</script>

<style lang="scss">
//今日工单弹窗的css
.my-dialog-class{
  display: flex;
  align-items: center;
  justify-content: center;
}
.my-modal-content{
  height: 98vh;
  width: 93vw;
}

.adsk-viewing-viewer {
  background: none !important;
}

.homeViewWrapper {
  display: none !important;
}

.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}


.card-border-custom {
  border-radius: 0;
  box-shadow: 0 0 1.5vw rgba(24, 144, 255, 0.2) inset;
  background: linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) left top,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) left top,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) right top,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) right top,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) left bottom,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) left bottom,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) right bottom,
  linear-gradient(rgba(24, 144, 255, 0.8), rgba(24, 144, 255, 0.8)) right bottom;
  background-repeat: no-repeat;
  background-size: 0.1vw 0.5vw, 0.5vw 0.1vw;
  height: 20vh;

}

.small_box {
  height: 10vh !important;
}

.middle_box {
  height: 12vh !important;
}

.inner_box {
  height: 5vh !important;
}

.card-title-custom {
  border-left: 0;
  width: calc(100% + 3rem);
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: .5rem;
  background-image: linear-gradient(rgba(24, 144, 255, 0), rgba(24, 144, 255, 0.2));
  border-bottom: 1px solid rgba(24, 144, 255, 0.7)
}
</style>
